import { ILogRowData } from "./utils";
import _ from "lodash";
import { IDateRange } from "./Components/DateRangeSelector";
import { ModelChart } from "./Custom/SingleDevicePieChart";
import { SingleDeviceTimeline } from "./Custom/SingleDeviceTimeline";
import { ReportModalButton } from "./Components/PDFGenerator";
import { analyticsChartModels, appChartConfig } from "./config";

const SingleDeviceDisplay = ({
  appId,
  logData,
  numDays,
  dateRange,
}: {
  appId: string;
  logData: ILogRowData[];
  numDays: number;
  dateRange: IDateRange;
}): JSX.Element => {
  const chartsToDisplay = appChartConfig.find(
    (app) => app.appId === appId
  )?.charts;

  return (
    <div className="space-y-4 relative">
      {logData.length > 0 && dateRange && (
        <>
          {chartsToDisplay ? (
            chartsToDisplay.map((model, index) => (
              <div className="py-2" key={index}>
                <ModelChart
                  model={model as keyof typeof analyticsChartModels}
                  displayData={logData}
                  dateRange={dateRange}
                  appId={appId}
                />
              </div>
            ))
          ) : (
            <div>
              <span className="text-red-500 font-bold">
                Invalid application ID
              </span>{" "}
              - please seek technical assistance with Lightwell
            </div>
          )}
          <div className="border-b" />
          <div className="space-y-2">
            <SingleDeviceTimeline
              logData={logData}
              numDays={numDays}
              dateRange={dateRange}
              appId={appId}
            />
          </div>
        </>
      )}
    </div>
  );
};

export { SingleDeviceDisplay };
